import React from 'react'
import { SlideShowE } from '../components/TractionPower/SlideShowE/SlideShowE'
import RDSO from '../components/TractionPower/Services/services'
import Traction from '../components/TractionPower/Traction'

const TractionPower = () => {
  return (
    <>
    <div className='TractionDIV'/>
   <Traction/>
   <SlideShowE/>
   <RDSO/>
    </>
  )
}

export default TractionPower
